import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';

@Injectable()
export class VehicleProvider {

  constructor(public http: HttpClient, private storage:Storage) {
    console.log('Hello VehicleProvider Provider');
  }

  URL = environment.ismUrl;

  getVehiclesDetail(){
    return this.getToken().then((val) => {
      if(val){
        let url = this.getUrl(`/my/vehicles`,val)
        return this.http.get<Response>(url)
        .toPromise();
      }
    });
  }
  getVehicleDetail(id){
    return this.getToken().then((val) => {
      if(val){
        let u = id && id != undefined ? `&id=${id}` : ''
        let url = this.getUrl(`/my/vehicles`,val)+u
        return this.http.get<Response>(url)
        .toPromise();
      }
    });
  }

  addVehicleDetail(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(`/my/vehicle`,val), data)
        .toPromise();
      }
    });
  }


  editVehicleDetail(data , id : number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/my/vehicle/${id}`,val), data)
        .toPromise();
      }
    });
  }


  deleteVehicleDetail(data){
    return this.getToken().then((val) => {
      if(val){
        let id = data.id
        return this.http.delete<Response>(this.getUrl(`/my/vehicle/${id}`,val), data)
        .toPromise();
      }
    });
  }

  updateVehicleSubscription(data){
    return this.getToken().then((val) => {
      if(val) {
        return this.http.post<Response>(this.getUrl(`/my/vehiclesubscription`,val),data)
        .toPromise();
      }
    });
  }
  addVehicleTag (data){
    return this.getToken().then((val) => {
      if(val){
        let id = data.id
        return this.http.post<Response>(this.getUrl(`/vehicletag/${id}`,val), data)
        .toPromise();
      }
    });
  }
  
  removeVehicleTag (data){
    return this.getToken().then((val) => {
      if(val){
        let id = data.id
        return this.http.delete<Response>(this.getUrl(`/vehicletag/${id}`,val), data)
        .toPromise();
      }
    });
  }

  vehicleTagAutoLock(data){
    return this.getToken().then((val) => {
      if(val) {
        return this.http.post<Response>(this.getUrl(`/my/vehicletagautolock/`+data.id,val),data)
        .toPromise();
      }
    });
  }

  vehicleLogs(VehicleId: number,from: String, to: String, getAll: boolean){
    return this.getToken().then((val) => {
      if(val){
        var str ='';
        if(getAll){
          str = `&get_all=1`;
        }
        return this.http.get<Response>(this.getUrl(`/my/vehicle/log`,val)+`&from=${from}&to=${to}&vehicle_id=${VehicleId}`+str)
        .toPromise();
      }
    });
  }
  getTagsetup(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/getSetups`,val)+ `&type=VEHICLE_TAG`)
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}


// WEBPACK FOOTER //
// ./src/providers/vehicle/vehicle.ts